<template>
  <v-flex xs12 md12 sm12>
    <v-layout
      ma-0
      pa-0
      class="row wrap"
      :class="{'creative-container-xs': $vuetify.breakpoint.xsOnly}"
      v-if="templates"
      :justify-center="$vuetify.breakpoint.xsOnly"
    >
      <v-flex
        :sm3="!isShortenFlow"
        :sm5="isShortenFlow"
        :lg3="!isShortenFlow"
        :lg5="isShortenFlow"
        xs5
        :md3="!isShortenFlow"
        :md5="!isShortenFlow"
        class="mr-3 ml-1 my-2"
        v-for="(template, index) in templates"
        :key="template.publishedRoimaticCreativeSetId"
      >
        <creative
          ref="creative"
          :index="index"
          :template="template"
          :is-template-clickable="true"
          @on-image-load-finished="setImageLoadFinished"
          @setTemplateId="setTemplateId"
        />
      </v-flex>
    </v-layout>
  </v-flex>
</template>
<script>
import { VLayout, VFlex } from 'vuetify/lib';
import Creative from './Creative';
import { mapActions, mapGetters } from 'vuex';
import { objectiveType, bizgainOnboardingRoutes, onboardingSections, imageLoadingStatus, getImageSourceForCreative } from 'Features/bizgainOnboarding/constants';
import { ApiService } from 'Features/bizgainOnboarding/services/apiService'
const apiService = new ApiService();
export default {
  props: ['creativeTemplates'],
  created() {
    if(!(this.businessDetails && this.businessDetails.shortenFlow) && !(this.roimaticConfiguration && this.roimaticConfiguration.shortenFlow)){
      this.setCurrentSection(onboardingSections.CREATIVE);
      if(this.isInAppCampaign){
        this.setCurrentRoute(bizgainOnboardingRoutes.SubsequentImageCreatives.name);
      }
      else{
        this.setCurrentRoute(bizgainOnboardingRoutes.ImageCreatives.name);
      }
    }

    this.templates.forEach(template=>{
      this.creativetemplateLoadStatus.push(imageLoadingStatus.inDom);
      if(!template.hasOwnProperty('leadImage')){
        this.hasLeadImage = false;
      }
      if(!template.hasOwnProperty('logo')){
        this.hasLogoImage = false;
      }
    });
  },
  async mounted(){
    if(!this.templates || !this.hasLeadImage || !this.hasLogoImage){
      let updateObjectivePayload = {
        sessionId: this.businessDetails.sessionId,
        objective: this.objective,
        isAsync: false
      };
      let creativeDetail = await apiService.creativeConfiguration(updateObjectivePayload);
      if (creativeDetail) {
        await this.getBusinessDetails({ sessionId: this.businessDetails.sessionId });
        this.$refs.creative.forEach(creativeInstance=>{
          creativeInstance.updateCreativeData();
        });
      }
    }else if(this.hasLeadImage && this.hasLogoImage){
      this.$refs.creative.forEach(creativeInstance=>{
        creativeInstance.updateCreativeData();
      });
    }

    this.imageObserver = new IntersectionObserver((entries) => {
      entries.forEach(async (entry) => {
        if (entry.isIntersecting) {
          entry.target.src = await getImageSourceForCreative(entry.target.dataset.src);
          this.creativetemplateLoadStatus[entry.target.id] = imageLoadingStatus.inProgress;
          this.imageObserver.unobserve(entry.target);
        }
      });
    });

    const images = document.querySelectorAll('img[data-src]');
    images.forEach((image) => {
      this.imageObserver.observe(image);
    });
  },
  data() {
    return {
      objectiveType,
      creativetemplateLoadStatus: [],
      imageObserver: null,
      isAllImageLoading: false,
      hasLeadImage: true,
      hasLogoImage: true
    };
  },
  methods: {
    ...mapActions(['setCurrentRoute', 'setCurrentSection', 'getBusinessDetails']),
    async setImageLoadFinished(index){
      this.creativetemplateLoadStatus[index] = imageLoadingStatus.finished;
      if(!this.creativetemplateLoadStatus.includes(imageLoadingStatus.inProgress) && !this.isAllImageLoading){
        this.isAllImageLoading = true;
        const images = document.querySelectorAll('img[data-src]');
        for (let image of images) {
          this.imageObserver.unobserve(image);
          const index = Array.from(images).indexOf(image);
          if (this.creativetemplateLoadStatus[index] == imageLoadingStatus.inDom) {
            image.src = await getImageSourceForCreative(image.dataset.src);
          }
        }
      }
    },
    setTemplateId(templateId){
      this.$emit('setTemplateId', templateId);
      this.dialog = false;
    }
  },
  computed: {
    ...mapGetters(['businessDetails', 'objective', 'isInAppCampaign', 'businessProfileId', 'roimaticCampaignId', 'roimaticConfiguration']),
    templates(){
      return this.creativeTemplates || (this.businessDetails && this.businessDetails.creativeDetail && this.businessDetails.creativeDetail.templates);
    },
    isShortenFlow(){
      if((this.businessDetails && this.businessDetails.shortenFlow) || (this.roimaticConfiguration && this.roimaticConfiguration.shortenFlow)){
        return true;
      }
      return false;
    }
  },
  components: {
    VLayout,
    VFlex,
    Creative
  }
};
</script>
<style scoped>
.creative-container-xs {
  width: 100vw !important;
  margin-left: -12px !important;
}
</style>
